import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

import { loadScript } from "../../utils/helperFunctions";
import PrimaryLoader from "../../components/loaders/PrimaryLoader";

const STATUS = {
    // status -> int : 1: pending, 2: success, 3: failed, 4: cancelled
    PENDING: 1,
    SUCCESS: 2,
    FAILED: 3,
    CANCELLED: 4,
    TIMEOUT: 5,
};

const Index = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const session_id = params.get("session_id");
    const [loading, setLoading] = useState(false);
    const [checkoutObjLoaded, setCheckoutObjLoaded] = useState(false);
    const [error, setError] = useState(false);

    const callPaymentGateway = useCallback(async () => {
        try {
            setLoading(true);
            await loadScript(process.env.REACT_APP_PAYMENT_GATEWAY);

            if (window.Checkout) {
                window.errorCallback = async (e) => {
                    toast.error(e?.["error.explanation"]);
                    setError(true);
                    sendMessage(STATUS.FAILED, e);
                };

                window.completeCallback = async (e) => {
                    toast.success("Payment Successful");
                    sendMessage(STATUS.SUCCESS, e);
                };

                window.timeoutCallback = (e) => {
                    sendMessage(STATUS.TIMEOUT, e);
                };

                window.cancelCallback = (e) => {
                    sendMessage(STATUS.CANCELLED, e);
                };

                const id = session_id;

                await window.Checkout.configure({
                    session: {
                        id: id,
                    },
                });

                setCheckoutObjLoaded(true);

                setLoading(false);
            } else {
                toast.error("Please try again.");
                setLoading(false);
            }
        } catch (error) {}
    }, [session_id]);

    useEffect(() => {
        if (!session_id) {
            toast.error("Session not found");
        } else {
            callPaymentGateway();
        }
        return () => {
            delete window.errorCallback;
            delete window.cancelCallback;
            delete window.completeCallback;
            delete window.timeoutCallback;
        };
    }, [session_id, callPaymentGateway]);

    useEffect(() => {
        if (checkoutObjLoaded && !error) {
            try {
                setLoading(true);
                window.Checkout?.showEmbeddedPage("#embed-target");
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
    }, [checkoutObjLoaded, error]);

    function sendMessage(status, result) {
        let response = {
            status: status,
            result: result,
        };
        window?.Gateway?.postMessage(JSON.stringify(response));
    }

    return (
        <>
            {loading && <PrimaryLoader />}
            <div id="embed-target" className="p-4"></div>
        </>
    );
};

export default Index;
